import projectCardData from '../data/projectcard.json';
import projectDetailsData from '../data/projectDetails.json';
import memberCardsData from '../data/people.json';
import memberDetailsData from '../data/memberDetails.json';
import groupCardsData from '../data/groups.json';

export async function getData(apiExtension) {
  console.log(`Getting data for: ${apiExtension}`);
  
  // Return mock data based on the API extension
  switch(apiExtension) {
    case 'projectCards':
      return projectDetailsData; // Using project details as cards
    case 'projectDetail':
      return projectDetailsData;
    case 'memberscards':
      return memberDetailsData; // Using member details as cards
    case 'memberdetails':
      return memberDetailsData;
    case 'groupcards':
      return groupCardsData;
    default:
      console.error(`No mock data available for ${apiExtension}`);
      return [];
  }
}

// Legacy function - maintaining for compatibility
export function useGetData(apiExtension) {
  return getData(apiExtension);
}
